import * as React from 'react';
import './TrialPresentationTypesPage.scss';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";
import ReactTable, { RowInfo } from 'react-table';
import * as TrialPresentationTypeActions from '../../../actions/trialPresentationTypes';
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState, IFormFilter } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { Link } from "../../../components/routing/index";
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from "../../../constants/reactTableConstants";
import * as AuthenticationHelper from '../../../helpers/authentication';
import { FormFilterInput } from '../../../components/form';
import { TrialLookupsLayout } from '../../index';
interface ITrialPresentationTypesPageProps {
  location: Location;
  history: History;

  // From state
  formFilter: IFormFilter;
  trialPresentationType: Dtos.TrialPresentationType[];
  loadingTrialPresentationTypes: boolean;
  loadTrialPresentationTypesSuccess: boolean;
  loadTrialPresentationTypesFailure: boolean;
  user: Dtos.User;
  permissions?: Dtos.PersonnelTmdPermissions[];
  formRoles?: Dtos.RoleType[];
}
interface ITrialPresentationTypesPageActions {
  clearTrialPresentationTypes: TrialPresentationTypeActions.ITrialPresentationTypeClearActionCreator;
  loadTrialPresentationTypes: TrialPresentationTypeActions.ITrialPresentationTypeLoadActionCreator;
  navigate: typeof routerActions.push;
  navigateReplace: typeof routerActions.replace;
  filter: TrialPresentationTypeActions.ITrialPresentationTypeFilterActionCreator;
}
type TrialPresentationTypesPageProps = ITrialPresentationTypesPageProps & ITrialPresentationTypesPageActions;
class TrialPresentationTypesPage extends React.PureComponent<TrialPresentationTypesPageProps, any> {
  constructor(props: TrialPresentationTypesPageProps) {
    super(props);
    this.clearTrialPresentationTypes = this.clearTrialPresentationTypes.bind(this);
  }
  componentDidMount() {
    const {
      loadTrialPresentationTypes
    } = this.props;
    loadTrialPresentationTypes();
  }
  componentWillReceiveProps(nextProps: TrialPresentationTypesPageProps) {}
  componentDidUpdate(prevProps: TrialPresentationTypesPageProps, prevState) {
    const {
      navigateReplace
    } = this.props;
  }
  componentWillUpdate(nextProps: TrialPresentationTypesPageProps) {}
  componentWillUnmount() {
    this.clearTrialPresentationTypes();
  }
  clearTrialPresentationTypes() {
    this.props.clearTrialPresentationTypes();
  }
  showTrialPresentationTypes(): boolean {
    const {
      loadingTrialPresentationTypes,
      loadTrialPresentationTypesSuccess
    } = this.props;
    if (!loadingTrialPresentationTypes && loadTrialPresentationTypesSuccess) {
      return true;
    }
    return false;
  }
  render() {
    const {
      loadingTrialPresentationTypes
    } = this.props;
    return <TrialLookupsLayout loading={loadingTrialPresentationTypes} permission={Dtos.Permission.TrialPresentationTypesView} data-sentry-element="TrialLookupsLayout" data-sentry-component="TrialPresentationTypesPage" data-sentry-source-file="TrialPresentationTypesPage.tsx">
            {this.renderContent()}
        </TrialLookupsLayout>;
  }
  renderContent() {
    const {
      permissions
    } = this.props;
    return <div>
            <div className="row">
                <div className={"col-6 mb-2"}>
                    <h2>Trial Presentation Types</h2>
                </div>
                <div className="col-6" style={{
          textAlign: 'right'
        }}>
                    <FormFilterInput formFilter={this.props.formFilter} onFilter={e => this.props.filter(e)} />
                    
                    {AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialPresentationTypesCreate) && <Link className={"btn btn-primary"} url={"/settings/trial/trialPresentationTypes/create"}>Create</Link>}
                </div>
            </div>
            {!this.showTrialPresentationTypes() ? "Loading Trial Presentation Types" : null}
            {this.showTrialPresentationTypes() ? <div className="patient-tables mt-2">
                        {this.createTable()}
                    </div> : null}
        </div>;
  }
  createTable() {
    const {
      trialPresentationType
    } = this.props;
    if (!trialPresentationType || trialPresentationType.length == 0) {
      return <div className="alert alert-info d-flex">
                <div className="mr-2">
                    <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                </div>
                <span>There are currently no trial presentation types to view.</span>
            </div>;
    }
    const showPagination = trialPresentationType.length > DEFAULT_PAGE_SIZE;
    return <div className="table-wrapper mb-3">
            <ReactTable data={trialPresentationType} pageSizeOptions={PAGE_SIZE_OPTIONS} defaultPageSize={showPagination ? DEFAULT_PAGE_SIZE : trialPresentationType.length} pageSize={showPagination ? undefined : trialPresentationType.length} showPagination={showPagination} className="-striped -highlight -clickable mb-3" noDataText="There are currently no trial presentation types to display" resizable={false} getTdProps={(state, rowInfo: RowInfo, column, instance) => {
        return {
          onClick: (e, handleOriginal) => {
            const url: string = "/settings/trial/trialPresentationTypes/" + rowInfo.original.id;
            this.props.navigate(url);
            if (handleOriginal) {
              handleOriginal();
            }
          },
          style: {
            color: rowInfo && rowInfo.original && rowInfo.original.active ? '#212529' : '#9e9e9e'
          }
        };
      }} columns={[{
        id: "id",
        Header: ' ',
        accessor: "id",
        className: "d-flex align-items-center justify-content-center",
        maxWidth: 50,
        Cell: props => <FontAwesomeIcon icon={FontAwesomeIcons.Light.LOOKUP} fixedWidth />
      }, {
        id: "value",
        Header: 'Name',
        accessor: 'value',
        className: "d-flex align-items-left justify-content-left",
        headerClassName: "text-left"
      }]} />
        </div>;
  }
}
const mapStateToProps = (state: ITmdState, ownProps: TrialPresentationTypesPageProps): ITrialPresentationTypesPageProps => {
  let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];
  return {
    history: ownProps.history,
    location: state.routing.location,
    formFilter: state.trialPresentationTypes.formFilter,
    trialPresentationType: state.trialPresentationTypes.formFilteredData,
    loadingTrialPresentationTypes: state.trialPresentationTypes.loadState && state.trialPresentationTypes.loadState.status == RequestState.Pending,
    loadTrialPresentationTypesSuccess: state.trialPresentationTypes.loadState && state.trialPresentationTypes.loadState.status == RequestState.Success,
    loadTrialPresentationTypesFailure: state.trialPresentationTypes.loadState && state.trialPresentationTypes.loadState.status == RequestState.Failure,
    user: state.user.data,
    permissions: permissions,
    formRoles: state.user.formRoles
  };
};
const mapDispatchToProps = (dispatch): ITrialPresentationTypesPageActions => {
  return {
    navigate: bindActionCreators(routerActions.push, dispatch),
    navigateReplace: bindActionCreators(routerActions.replace, dispatch),
    loadTrialPresentationTypes: bindActionCreators(TrialPresentationTypeActions.LoadTrialPresentationType, dispatch),
    clearTrialPresentationTypes: bindActionCreators(TrialPresentationTypeActions.Clear, dispatch),
    filter: bindActionCreators(TrialPresentationTypeActions.Filter, dispatch)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(TrialPresentationTypesPage);